var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "csawsshipment"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-2",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    staticStyle: {
      "color": "#20a8d8",
      "float": "left"
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("CSAW Type")]), _vm._v(" "), _c('b-form-fieldset', [_c('label', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.search.scawtype),
      expression: "search.scawtype"
    }],
    attrs: {
      "type": "radio",
      "name": "csawtype",
      "value": "Forward"
    },
    domProps: {
      "checked": _vm._q(_vm.search.scawtype, "Forward")
    },
    on: {
      "click": _vm.csawTypeSelection,
      "__c": function($event) {
        _vm.search.scawtype = "Forward"
      }
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n                        Forward")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.search.scawtype),
      expression: "search.scawtype"
    }],
    attrs: {
      "type": "radio",
      "name": "csawtype",
      "value": "Reverse"
    },
    domProps: {
      "checked": _vm._q(_vm.search.scawtype, "Reverse")
    },
    on: {
      "click": _vm.csawTypeSelection,
      "__c": function($event) {
        _vm.search.scawtype = "Reverse"
      }
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n                        Reverse")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Search Date Criteria")]), _vm._v(" "), _c('b-form-fieldset', [_c('label', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.search.criteria),
      expression: "search.criteria"
    }],
    attrs: {
      "type": "radio",
      "name": "csawupdate",
      "value": "csawupdate"
    },
    domProps: {
      "checked": _vm._q(_vm.search.criteria, "csawupdate")
    },
    on: {
      "__c": function($event) {
        _vm.search.criteria = "csawupdate"
      }
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("CSAW Update Date")])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.search.criteria),
      expression: "search.criteria"
    }],
    attrs: {
      "type": "radio",
      "name": "inscan",
      "value": "inscan"
    },
    domProps: {
      "checked": _vm._q(_vm.search.criteria, "inscan")
    },
    on: {
      "__c": function($event) {
        _vm.search.criteria = "inscan"
      }
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("Inscan Date")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.tillDate2,
      "not-after": _vm.toDate
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromDate,
      "not-after": _vm.tillDate1
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.clientData,
      "name": "clientData",
      "selected-options": _vm.clientItems,
      "placeholder": "Search Client",
      "track-by": "text",
      "label": "text",
      "hide-selected": false
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.search.client),
      callback: function($$v) {
        _vm.search.client = $$v
      },
      expression: "search.client"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.zoneData,
      "selected-option": _vm.selectedZoneObj,
      "placeholder": "Select Zone"
    },
    on: {
      "select": _vm.selectedZone
    },
    model: {
      value: (_vm.search.zone),
      callback: function($$v) {
        _vm.search.zone = $$v
      },
      expression: "search.zone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Current Hub")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.hubData,
      "isDisabled": _vm.hubSelect,
      "selected-option": _vm.selectedHubObj,
      "placeholder": "Search hub"
    },
    on: {
      "select": _vm.selectedHubData
    },
    model: {
      value: (_vm.search.hub),
      callback: function($$v) {
        _vm.search.hub = $$v
      },
      expression: "search.hub"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Last NDR/NPR")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-pencil-square-o'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.statusCodeData,
      "selected-option": _vm.selectedStatusCodeObj,
      "placeholder": "Search Status Code"
    },
    on: {
      "select": _vm.selectedStatusCodeData
    },
    model: {
      value: (_vm.search.statuscode),
      callback: function($$v) {
        _vm.search.statuscode = $$v
      },
      expression: "search.statuscode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Notification Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bell'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.notificationtype),
      expression: "search.notificationtype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "notificationtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.notificationtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _vm._l((_vm.notificationTypesData), function(types) {
    return _c('option', {
      domProps: {
        "value": types.typename
      }
    }, [_vm._v(_vm._s(types.typename) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), (_vm.search.scawtype == 'Reverse') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Notification Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-exclamation-triangle'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.notificationstatus),
      expression: "search.notificationstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "withbucket"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.notificationstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _vm._l((_vm.withBucketData), function(buckets) {
    return _c('option', {
      domProps: {
        "value": buckets.statusvalue
      }
    }, [_vm._v("\n                        " + _vm._s(buckets.statustext))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.search.scawtype == 'Forward') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Notifcation Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-exclamation-triangle'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.notificationstatus),
      expression: "search.notificationstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "notificationstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.notificationstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _vm._l((_vm.notificationStatusData), function(notistatus) {
    return _c('option', {
      domProps: {
        "value": notistatus.statusvalue
      }
    }, [_vm._v("\n                        " + _vm._s(notistatus.statustext))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gift'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID"
    },
    model: {
      value: (_vm.search.shippingid),
      callback: function($$v) {
        _vm.search.shippingid = $$v
      },
      expression: "search.shippingid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-left": "951px",
      "padding-right": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchButton
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-right": "5px",
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v("\n                    Clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn1",
    staticStyle: {
      "padding-top": "5px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-right": "0px",
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.exportCSAWListing()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export")])])])])])])])])], 1)], 1), _vm._v(" "), (_vm.search.scawtype == 'Forward' && _vm.showList == 1) ? _c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "margin-bottom": "2rem"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CSAW Shipment List :\n              "), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "border-radius": "8px",
      "padding": "3px 8px",
      "background-color": "#f86c6b",
      "margin": "10px 5px 5px"
    },
    attrs: {
      "data-v-3188e7ab": ""
    }
  }, [_vm._v(_vm._s(_vm.listTotalCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Raise\n              Ticket")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto",
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.scawshipments), function(data, index) {
    return (_vm.scawshipments.length > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shippingIDS),
        expression: "shippingIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.shippingid,
        "checked": Array.isArray(_vm.shippingIDS) ? _vm._i(_vm.shippingIDS, data.shippingid) > -1 : (_vm.shippingIDS)
      },
      on: {
        "click": function($event) {
          _vm.select(data, index, $event)
        },
        "change": function($event) {
          _vm.resetAll(data)
        },
        "__c": function($event) {
          var $$a = _vm.shippingIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.shippingid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.shippingIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.shippingIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.shippingIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: data.shippingid
          }
        }
      }
    }, [_vm._v("\n                      " + _vm._s(data.shippingid) + "\n                  ")])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showShipmentLogModal(data.shippingid)
        }
      }
    }, [_vm._v("View Log")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), (data.inscandate == '') ? _c('td', [_c('center', [_vm._v("-")])], 1) : _vm._e(), _vm._v(" "), (data.inscandate != '') ? _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.inscandate)))]) : _vm._e(), _vm._v(" "), (data.ordertype == '') ? _c('td', [_c('center', [_vm._v("-")])], 1) : _vm._e(), _vm._v(" "), (data.ordertype != '') ? _c('td', [_vm._v(_vm._s(data.ordertype))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.latestprocess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalattempts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.lastupdateddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.prexoId || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.associateShippingId || '-'))])]) : _vm._e()
  }), _vm._v(" "), (_vm.scawshipments.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pageCount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.search.scawtype == 'Reverse' && _vm.showList == 1) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px",
      "margin-bottom": "2rem"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CSAW Shipment List :\n              "), _c('span', {
    staticClass: "badge",
    staticStyle: {
      "border-radius": "8px",
      "padding": "3px 8px",
      "background-color": "#f86c6b",
      "margin": "10px 5px 5px"
    },
    attrs: {
      "data-v-3188e7ab": ""
    }
  }, [_vm._v(_vm._s(_vm.listTotalCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Raise\n              Ticket")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.scawshipments), function(data, index) {
    return (_vm.scawshipments.length > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shippingIDS),
        expression: "shippingIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.shippingid,
        "checked": Array.isArray(_vm.shippingIDS) ? _vm._i(_vm.shippingIDS, data.shippingid) > -1 : (_vm.shippingIDS)
      },
      on: {
        "click": function($event) {
          _vm.select(data, index, $event)
        },
        "change": function($event) {
          _vm.resetAll(data)
        },
        "__c": function($event) {
          var $$a = _vm.shippingIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.shippingid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.shippingIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.shippingIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.shippingIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: data.shippingid
          }
        }
      }
    }, [_vm._v("\n                      " + _vm._s(data.shippingid) + "\n                  ")])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showShipmentLogModal(data.shippingid)
        }
      }
    }, [_vm._v("View Log")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.inscandate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.latestprocess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalattempts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.lastupdateddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.prexoId || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.associateShippingId || '-'))])]) : _vm._e()
  }), _vm._v(" "), (_vm.scawshipments.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pageCount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.Ticketmodal),
      callback: function($$v) {
        _vm.Ticketmodal = $$v
      },
      expression: "Ticketmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Ticketmodal),
      expression: "Ticketmodal"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "id": "csawAddTicketDiv"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('Ticketmodal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "act_panel",
    staticStyle: {
      "height": "20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 "
  }, [_c('div', {
    staticClass: "row scrollDivShipmentGrid"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Source\n                          "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Search Tagging : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tag"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "49%"
    },
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Reason\n                            "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [((_vm.selectedReasonObj.text == 'Arrange delivery' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    (_vm.selectedReasonObj.text == 'Arrange pickup' && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM) ||
    ((_vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP) && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM)) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Reattempt Date "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                        ")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "float": "left",
      "width": "49%"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Sub\n                            Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("\n                            Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                          ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form_btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkShipment($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetAddTicket($event)
      }
    }
  }, [_vm._v("Reset")])])])])])])])])])], 1)])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.ticketResultModal),
      callback: function($$v) {
        _vm.ticketResultModal = $$v
      },
      expression: "ticketResultModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticketResultModal),
      expression: "ticketResultModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Result ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Close ")])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.ShipmentLogModal),
      callback: function($$v) {
        _vm.ShipmentLogModal = $$v
      },
      expression: "ShipmentLogModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShipmentLogModal),
      expression: "ShipmentLogModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Shipment Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ShipmentLogModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h5', {
    staticClass: "ship_id_head",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Shipment Logs: "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.displayshippingid))])])]), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("Process Location")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), _c('th', [_vm._v("User Name")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ShipmentLog.ShipmentLogBarArr), function(ShipmentLogTblEle, index) {
    return (_vm.ShipmentLog.ShipmentLogCnt > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "width": "70px"
      }
    }, [_vm._v(_vm._s(ShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserName))])]) : _vm._e()
  }))])])])])], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('p', [_vm._v("CSAW Details")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("View Log")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Inscan Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last NDR/NPR")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Attempt Count")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CSAW Update Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CSAW Comment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Prexo ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Associated Shipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("View Log")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Inscan Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last NDR/NPR")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Attempt Count")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CSAW Update Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CSAW Comment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Prexo ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Associated Shipment")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27166962","hasScoped":true}!./src/views/components/CSAWShipments/csawshipments.component.html
// module id = 873
// module chunks = 1